import React from 'react'
import { Cell, Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'

function RowPreloader() {
    return (
        <div className={styles.row}>
            <Cell
                left={<Loader width={44} height={44} isCircled />}
                title={
                    <div className={styles.rowLeftTop}>
                        <Loader width={40} height={16} />
                    </div>
                }
                caption={<Loader width={55} height={14} />}
                details={
                    <div className={styles.cell}>
                        <Loader width={100} height={16} />
                        <Loader width={64} height={14} />
                    </div>
                }
                right={
                    <div className={styles.cell}>
                        <Loader width={100} height={16} />
                        <Loader width={64} height={14} />
                    </div>
                }
            />
        </div>
    )
}

function Preloader() {
    return (
        <div>
            <div className={styles.header}>
                <Loader width={100} height={14} />
                <div className={styles.rightColumn}>
                    <Loader width={100} height={14} />
                    <Loader width={100} height={14} />
                </div>
            </div>

            {Array.from({ length: 9 }).map((_, index) => (
                <RowPreloader key={index} />
            ))}
        </div>
    )
}

export default Preloader
